import { Text } from '@shared/components'
import {
  Card,
  CheckboxOptionType,
  Col,
  ColProps,
  Flex,
  Radio,
  RadioChangeEvent,
  RadioGroupProps,
  Row
} from 'antd'

import { useStyles } from './styles'

export type RadioCardGroupOption = {
  label: React.ReactNode
  value: CheckboxOptionType['value']
  colProps?: ColProps
  description?: React.ReactNode
  disabled?: boolean
  onChange?: (e: RadioChangeEvent) => void
}

type Props = {
  options?: RadioCardGroupOption[]
} & Omit<RadioGroupProps, 'options'>

export const RadioCardGroup = ({ options, className, ...props }: Props) => {
  const { styles, cx } = useStyles()

  return (
    <Radio.Group className={cx(styles.radioGroup, className)} {...props}>
      <Row gutter={[12, 12]}>
        {options?.map(
          (
            { label, value, colProps, description, disabled, onChange },
            idx
          ) => (
            <Col key={idx} {...colProps}>
              <Card
                size="small"
                className={styles.cardRoot}
                classNames={{ body: styles.cardBody }}
              >
                <Radio
                  value={value}
                  className={styles.radio}
                  disabled={disabled}
                  onChange={onChange}
                >
                  <Flex vertical>
                    <span>{label}</span>
                    {!!description && (
                      <Text type="secondary">{description}</Text>
                    )}
                  </Flex>
                </Radio>
              </Card>
            </Col>
          )
        )}
      </Row>
    </Radio.Group>
  )
}
